import Vue from "vue";
import Router from "vue-router";
import GettingStarted from "./views/GettingStarted.vue";
import News from "./views/News.vue";
import Terms from "./views/Terms.vue";
import ApiAccounts from "./views/ApiAccounts";
import TPPCertificate from "./views/TPPCertificate";
import QSEALCertificate from "./views/QSEALCertificate";
import ApiPayments from "./views/ApiPayments";
import ApiAccountList from "./views/ApiAccountList";
import SingleNews from "./views/SingleNews";
import SinglePage from "./views/SinglePage";
import Store from "./store/index";

const pagesDir = "/p";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: GettingStarted,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: pagesDir + "/confirm",
      name: "confirm",
      component: GettingStarted,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: pagesDir + "/home",
      name: "getting-started",
      component: GettingStarted,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: pagesDir + "/news",
      name: "news",
      component: News,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: pagesDir + "/tpp-certificate",
      name: "tpp-certificate",
      component: TPPCertificate
    },
    {
      path: pagesDir + "/qseal-certificate",
      name: "qseal-certificate",
      component: QSEALCertificate
    },
    {
      path: pagesDir + "/news/*",
      name: "single-news",
      component: SingleNews,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: pagesDir + "/pages/*",
      name: "single-page",
      component: SinglePage,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: pagesDir + "/api-explorer-account-list",
      name: "api-explorer-account-list",
      component: ApiAccountList
    },
    {
      path: pagesDir + "/api-explorer-accounts",
      name: "api-explorer-accounts",
      component: ApiAccounts
    },
    {
      path: pagesDir + "/api-explorer-payments",
      name: "api-explorer-payments",
      component: ApiPayments
    },
    {
      path: pagesDir + "/terms-of-use",
      name: "terms",
      component: Terms,
      meta: {
        requiresAuth: false
      }
    },
    { path: "*", redirect: '/p/pages/404' }
  ]
});

function hideMenu() {
  var t = document.getElementsByClassName("header--sub-menu-close-button")[0];
  void 0 !== t && null !== t && t.click();
  t = document.getElementsByClassName("header-mobile--main-toggle-click-area")[1];
  void 0 !== t && null !== t && t.click();
}

router.beforeEach((to, from, next) => {
  document.title = window.defaultTitle;
  $("meta[name='description']").attr("content", "");

  hideMenu();

  var requiresAuth = true;
  if (to.meta.hasOwnProperty("requiresAuth")) {
    requiresAuth = to.meta.requiresAuth;
  }
  if (requiresAuth) {
    if (Store.getters.isAuthenticated) {
      return next();
    } else {
      Store.dispatch("loginWindow");
    }
  } else {
    next();
  }
});

export default router;
